import { render } from "./eduActivityInfo.vue?vue&type=template&id=a27a3cf6&scoped=true"
import script from "./eduActivityInfo.vue?vue&type=script&lang=js"
export * from "./eduActivityInfo.vue?vue&type=script&lang=js"

import "./eduActivityInfo.vue?vue&type=style&index=0&id=a27a3cf6&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a27a3cf6"]])

export default __exports__